import { push } from 'react-router-redux';

import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// RESET PASSWORD
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////


export const requestResetPassword = packet => {
  return {
    type: 'REQUEST_RESET_PASSWORD',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveResetPasswordSuccess = data => ({
  type: 'RECEIVE_RESET_PASSWORD_SUCCESS',
  data
})

export const receiveResetPasswordFail = data => ({
  type: 'RECEIVE_RESET_PASSWORD_FAIL',
  data
})

export const tryToResetPassword = packet => dispatch => {
  dispatch(requestResetPassword(packet));
  
  return fetch('/api/users/reset-password', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: {
      "Content-Type": "application/json"
    }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveResetPasswordSuccess(json));
      return dispatch(push('/login'));
    })
    .catch(e => {
      revokeTokenHandler(e);
      return dispatch(receiveResetPasswordFail({errors:e, lastSubmit: packet}));
    })
}



// WEBPACK FOOTER //
// ./src/actions/user/a.u.POST.reset-password.js